import { Checkbox } from '@pluxee-design-system/core';
import { getCheckBoxValue } from 'common/forms/utils';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { LocationEmployeeItem } from 'generated/models';
import { get } from 'lodash';
import { ChangeEvent, useCallback } from 'react';
import { useController } from 'react-hook-form';

const LocationAccessCell = ({
  row: { editor, editorEnabled, location },
  extra: isDisabled,
}: ComponentProps<LocationEmployeeItem, boolean, boolean>) => {
  const { field } = useController({ name: 'locationsAccess' });
  const { onChange } = field;
  const index = location.uid;
  const currentValue = get(field.value, `${index}.newState`, editor ?? false);

  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      onChange(getCheckBoxValue(editor, event.target.checked, field.value, index)),
    [editor, field.value, index, onChange],
  );

  return (
    <Checkbox
      name={`locationsAccess.${index}.newState`}
      isDisabled={isDisabled || !editorEnabled}
      id={`locationsAccess.${index}`}
      isChecked={currentValue}
      onChange={handleOnChange}
    />
  );
};

export default LocationAccessCell;
